"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainMenu = /** @class */ (function () {
    function MainMenu() {
        var _this = this;
        this.menuExpandedClass = 'primary-submenu-wrapper--expanded';
        this.idDesktopClass = 'masthead--desktop';
        this.isMobileClass = 'masthead--mobile';
        this.init = function () {
            _this.attachEvents();
            _this.checkViewportWidth();
        };
        this.checkViewportWidth = function () { return _this.appendSubMenu(window.innerWidth > 1030); };
        this.$container = $('#masthead');
        this.$subMenu = $('.primary-submenu-wrapper');
        this.$mobileCart = $('.mobile-menu .widget_shopping_cart');
        this.$cartBtn = $('.mobile-menu .site-header-cart');
        this.$closeCartBtn = $('.mobile-menu .widget_shopping_cart .close-mini-cart');
        this.init();
    }
    MainMenu.prototype.attachEvents = function () {
        var _this = this;
        $('.mobile-menu__toggle').on('click', function (e) { return _this.toggleMenu(e); });
        var parent = this;
        this.$mobileCart.addClass('hide-cart');
        this.$cartBtn.on('click', function () { return _this.$mobileCart.toggleClass('hide-cart'); });
        this.$closeCartBtn.on('click', function () { return _this.$mobileCart.toggleClass('hide-cart'); });
        $(window).on('resize', function () { return _this.checkViewportWidth(); });
        $('.primary-navigation').find('.menu-item > a').on('click', function (e) {
            if ($(this).attr('href') === '#') {
                e.preventDefault();
                var linkId = $(this).parent().attr('id');
                if (linkId) {
                    parent.openSubMenu(linkId);
                }
            }
        });
    };
    MainMenu.prototype.openSubMenu = function (linkId) {
        var $showItem = $("#submenu-".concat(linkId));
        var $otherSubmenus = $showItem.siblings('.primary-submenu-wrapper');
        $otherSubmenus.hide();
        $otherSubmenus.removeClass(this.menuExpandedClass);
        $showItem.show();
        $showItem.toggleClass(this.menuExpandedClass);
    };
    MainMenu.prototype.appendSubMenu = function (isDesktop) {
        var menuAppendedClass = isDesktop ? this.idDesktopClass : this.isMobileClass;
        if (!this.$container.hasClass(menuAppendedClass)) { // check id menu is already appended
            this.$container.removeClass(this.idDesktopClass);
            this.$container.removeClass(this.isMobileClass);
            this.$subMenu.removeClass(this.menuExpandedClass);
            this.$container.addClass(menuAppendedClass);
            if (menuAppendedClass === this.idDesktopClass) { // remove style attr added by mobile menu plugin
                this.$container.removeAttr("style");
            }
            this.$subMenu.each(function (index, el) {
                var menuId = $(el).attr('id');
                var targetId = isDesktop ? "masthead" : menuId.split('submenu-')[1];
                $("#".concat(menuId)).appendTo("#".concat(targetId));
            });
        }
    };
    MainMenu.prototype.toggleMenu = function (e) {
        var _this = this;
        e.preventDefault();
        var expandedClass = 'masthead-expanded';
        if (this.$container.hasClass(expandedClass)) {
            this.$container.removeClass(expandedClass);
            setTimeout((function () { return _this.$container.animate({ minHeight: '80px' }, 450); }), 200);
        }
        else {
            this.$container.addClass(expandedClass);
            this.$container.animate({ height: '375px' }, 400);
            setTimeout((function () {
                if (_this.$container.css('height') > '1') {
                    _this.$container.css('height', 'auto');
                }
            }), 500);
            this.$container.animate({ minHeight: '375px' }, 200);
        }
    };
    return MainMenu;
}());
exports.default = MainMenu;
